import React, {useState} from 'react';
import clsx from "clsx";

import {INPUT_TYPES} from "../../types";
import {Validators} from "../../utils";

const { validateMobilePhone } = Validators;

const Input = (
  {
    className,
    placeholder,
    onChange,
    type = INPUT_TYPES.TEXT,
    defaultValue,
    value,
    id,
    name,
    error
  }: {
    className?: string;
    placeholder?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    type?: string;
    defaultValue?: string;
    id?: string;
    name?: string;
    value?: string;
    error?: string | boolean;
    helperText?: any;
  }
) => {
  return <div className="relative">
    <input
      className={
        clsx("block w-[200px] py-[7px] border border-solid border-mainBlack/10 px-2 outline-none text-black rounded-sm text-sm leading-[16px]", className)
      }
      id={id}
      name={name}
      type={type}
      value={value}
      placeholder={placeholder || ''}
      defaultValue={defaultValue || ''}
      onChange={onChange}
    />
    {error && <span className="absolute bottom-[-15px] text-rose-700 text-xs">{error}</span>}
  </div>
};

export default Input;
